import { Button } from '@chakra-ui/react'
import { format, set } from 'date-fns'
import React, { Suspense } from 'react'
import { withTranslation } from 'react-i18next'
import { GrPowerReset } from 'react-icons/gr'
import TimeRange from 'react-timeline-range-slider'
import { Col, Row } from 'reactstrap'
import { ChartDetail } from './'

const startDate = new Date()

const getDate = (date = 1) => set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0, date: date })

const selectedInterval = [getDate(startDate.getDate() - 30), set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })]
const timelineInterval = [getDate(startDate.getDate() - 30), set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })]

class SectionBoard extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			meta: props.meta,
			envityValues: props.entityValues,
			name: props.name,
			idKey: props.meta && props.meta.idKey,
			itemId: props.params && props.params.itemId,
			selectedInterval,
			error: false,
		}
		// this.handleChange.bind(this)
	}
	componentWillReceiveProps(props) {
		const { meta } = this.props
		// const { sections } = meta
		// const itemsByCols = {}
		// const secDef = sections[name]

		this.setState({ meta: props.meta, filterValues: props.filterValues, idKey: props.meta.idKey, itemId: props.params && props.params.itemId })
	}
	// handleChange(...args) {
	//     this.props.handleChange(args)
	// }
	// handleSelection(...args) {
	//     this.props.handleSelection(args)
	// }

	errorHandler = ({ error }) => this.setState({ error })

	onChangeCallback = selectedInterval => {
		this.setState({ selectedInterval }, () => {
			this.props.dimensionData &&
				this.props.dimensionData
					.filter(d => d['createdDate'])[0]
					['createdDate'].dim.filter(d => {
						return d[0] >= format(new Date(selectedInterval[0]), 'yyyy-MM-dd') && d[0] <= format(new Date(selectedInterval[1]), 'yyyy-MM-dd')
					})
			this.props.redrawAll()
		})
	}

	tickFormatter = timestamp_measured => {
		return format(new Date(timestamp_measured), 'dd MMM')
	}

	resetFilter = () => {
		this.setState({ selectedInterval: selectedInterval })
		this.props.dimensionData &&
			this.props.dimensionData.forEach(d => {
				Object.keys(d).forEach(dimData => d[dimData].dim.filterAll())
			})
		this.props.redrawAll()
	}

	currentDateFilter = () => {
		let currentDateInterval = [
			set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }),
			set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }),
		]
		this.setState({ selectedInterval: currentDateInterval }, () => {
			this.props.dimensionData &&
				this.props.dimensionData
					.filter(d => d['createdDate'])[0]
					['createdDate'].dim.filter(d => {
						return d[0] >= format(new Date(currentDateInterval[0]), 'yyyy-MM-dd') && d[0] <= format(new Date(currentDateInterval[1]), 'yyyy-MM-dd')
					})
			this.props.redrawAll()
		})
	}
	renderItem(item) {
		if (!item) return
		const { charts, sections, cards, lists, fields, tabs, actions, treeTables } = this.props.meta
		const { data, filterValues, dimensionData, t } = this.props
		const { selectedInterval, error } = this.state
		// const {  filterValues } =  this.props
		// const title = (dashboard && dashboard.title) || ((this.props.meta.name || this.props.moduleName) + ' Dashboard')
		let itemDef
		let dependsOn
		switch (item.type) {
			case 'section':
				itemDef = sections[item.name]
				if (itemDef)
					return (
						<Row className="my-1" key={item.name}>
							<SectionBoard {...this.props} key={item.name} name={item.name} />
						</Row>
					)
				break
			case 'field':
				itemDef = fields[item.name]
				if (itemDef) {
					if (itemDef.dependsOnFields && itemDef.dependsOnFields.pop && filterValues) {
						dependsOn = {}
						itemDef.dependsOnFields.forEach(f => {
							dependsOn[f] = filterValues[f]
						})
					}
					return (
						<Row className="my-1" key={item.name}>
							<div>
								<span> {t('Selected Interval')}: </span>
								{selectedInterval.map((d, i) => (
									<span key={i}>{i !== 0 ? ' - ' + format(d, 'dd MMM') : format(d, 'dd MMM')}</span>
								))}
								<span style={{ marginLeft: '10px' }}>
									<Button onClick={this.resetFilter} leftIcon={<GrPowerReset />} colorScheme="teal" variant="outline">
										{t('Reset All')}
									</Button>
								</span>
								<span style={{ marginLeft: '10px' }}>
									<Button onClick={this.currentDateFilter} colorScheme="teal" variant="outline">
										{t('Today')}
									</Button>
								</span>
							</div>
							<div style={{ width: '100%' }}>
								<TimeRange
									error={this.state.error}
									ticksNumber={30}
									selectedInterval={this.state.selectedInterval}
									timelineInterval={timelineInterval}
									onUpdateCallback={this.errorHandler}
									onChangeCallback={this.onChangeCallback}
									formatTick={this.tickFormatter}
								/>
							</div>
						</Row>
					)
				}
				break
			case 'chart':
				itemDef = charts[item.name]
				if (itemDef) {
					if (itemDef.dependsOnFields && itemDef.dependsOnFields.pop && filterValues) {
						dependsOn = {}
						itemDef.dependsOnFields.forEach(f => {
							dependsOn[f] = filterValues[f]
						})
					}
					return (
						<div key={item.name}>
							<ChartDetail
								chart={itemDef}
								{...this.props}
								data={data}
								dimensionData={dimensionData}
								key={item.name}
								dependsOn={dependsOn}
								name={item.name}
								filterValues={filterValues}
							/>
						</div>
					)
				}
				break
			default:
		}
	}
	render() {
		const { filterValues, meta, name, t } = this.props
		const { fields, sections } = meta
		const itemsByCols = {}
		const secDef = sections[name]
		// let setPageFilters = false
		let pageFilters = { ...filterValues }
		secDef &&
			secDef.cols &&
			secDef.items.forEach(i => {
				if (i.type === 'field' && fields[i.name].value && !(filterValues && filterValues[i.name])) {
					pageFilters[i.name] = fields[i.name].value.value || fields[i.name].value.label || fields[i.name].value
					// setPageFilters = true
				}
				if (i.col) {
					itemsByCols[i.col] = itemsByCols[i.col] || []
					itemsByCols[i.col].push(i)
				} else {
					itemsByCols.unassigned = itemsByCols.unassigned || []
					itemsByCols.unassigned.push(i)
				}
			})
		// if(setPageFilters) this.props.setPageFilters(pageFilters)
		itemsByCols.unassigned = itemsByCols.unassigned || (secDef && !secDef.cols && secDef.items)
		let Component
		let compProps = {}
		if (secDef) {
			// let cPath = path.join('./../../../..' , (secDef.path||'') ,  secDef.component)
			// path = './test/DetailHeader'
			// console.error(`Components: ${Object.keys(EntityComponents)}`)

			//Component = DashboardComponents[secDef.component]

			if (secDef.props) {
				Object.keys(secDef.props).forEach(k => {
					if (typeof secDef.props[k] === 'string') compProps[k] = filterValues && filterValues[secDef.props[k]]
				})
			}
			if (secDef.loadList && this.state.linkedLists) {
				// the lists that are attached to this component and loaded here.
				compProps[secDef.loadList.targetProp] = this.state.linkedLists[secDef.loadList.targetProp]
			}
		}

		if (secDef && secDef.cols && itemsByCols.unassigned) {
			console.error(`Some elements are not assigned to columns ${itemsByCols.unassigned}`)
			return <div></div>
		} else
			return (
				<Suspense fallback={<h2> {(t && t('Loading')) || 'Loading...'}</h2>}>
					{secDef && secDef.cols && (
						<>
							{/* {secDef.title && 
                             <div className=" text-center small">{secDef.title}:</div>
                            } */}
							{secDef.cols.map((c, i, arr) => {
								return (
									<Col sm={c} key={i + 1}>
										{itemsByCols[i + 1] &&
											itemsByCols[i + 1].map(item => {
												return this.renderItem(item)
											})}
									</Col>
								)
							})}
						</>
					)}
					{itemsByCols &&
						itemsByCols.unassigned &&
						itemsByCols.unassigned.map(item => {
							return (
								<Col sm={12} key={item.name}>
									{this.renderItem(item)}
								</Col>
							)
						})}
					{/* {
                        // component 
                        Component && <Component {...this.props}{...compProps} propsMap={secDef.otherProps} />
                    } */}
				</Suspense>
			)
	}
}
export default withTranslation()(SectionBoard)
